/**
 * Created by Andrey Popov on 22.04.2025
 */

const CompetitionDataSource = function (competition) {
    cleverapps.EventEmitter.call(this);

    this.competition = competition;

    this.competition.onChangeResultsListeners.dataSource = this.onChangeResults.bind(this);
};

CompetitionDataSource.prototype = Object.create(cleverapps.EventEmitter.prototype);
CompetitionDataSource.prototype.constructor = CompetitionDataSource;

CompetitionDataSource.prototype.getData = function () {
    return this.competition.getResults().map((result) => {
        let prizeIcon;
        let prizeRewards;
        let rewards = this.competition.options.getPrizeByPlace(result.place - 1);
        const nextPlaceRewards = this.competition.options.getPrizeByPlace(result.place);
        if (rewards) {
            const frames = (bundles[this.competition.options.prizeIconsBundle] || bundles.table).frames;

            const isUniqueReward = JSON.stringify(rewards) !== JSON.stringify(nextPlaceRewards);
            if (isUniqueReward) {
                prizeIcon = frames[`prize_${result.place}`] || frames.prize_5;
            } else {
                prizeIcon = frames.prize_5;
            }

            if (rewards.unit && ["merge", "merge2"].includes(cleverapps.config.type)) {
                const { unit, ...restRewards } = rewards;
                rewards = { ...restRewards, units: cleverapps.toArray(unit) };
            }
            prizeRewards = rewards;
        }

        return {
            id: result.id,
            weight: -result.place,
            score: result.amount,
            pinned: result.player,
            data: {
                player: result.player,
                name: result.name,
                place: result.place,
                prizeIcon,
                prizeRewards,
                avatar: {
                    id: result.id,
                    avatar: result.avatar
                }
            }
        };
    });
};

CompetitionDataSource.prototype.onChangeResults = function () {
    this.trigger("updateAll");
};

CompetitionDataSource.prototype.destructor = function () {
    delete this.competition.onChangeResultsListeners.dataSource;
};